import type { FileUpload } from 'graphql-upload/GraphQLUpload.js'
import GraphQLUpload from 'graphql-upload/GraphQLUpload.js'
import { ObjectType, Field, InputType, Int, ID, registerEnumType } from 'type-graphql'
import { ObjectRef, ScalarObject } from '@things-factory/shell'

import { KpiPeriodType } from '../kpi/kpi'
import { KpiMetricCollectType } from './kpi-metric'
import { KpiMetric } from './kpi-metric'

@InputType({ description: 'Input type for creating a new KPI metric. Used in mutations to provide metric details.' })
export class NewKpiMetric {
  @Field({ description: 'Metric code, unique within the domain, used in KPI formulas.' })
  name: string

  @Field({ nullable: true, description: 'User-friendly name or description of the metric.' })
  description?: string

  @Field({ nullable: true, description: 'Unit of measurement for this metric (e.g., %, count, hours).' })
  unit?: string

  @Field({ nullable: true, description: 'Source of the metric data (e.g., system, method, dataset).' })
  source?: string

  @Field(type => ObjectRef, { nullable: true, description: 'Source dataset for this metric.' })
  dataSet?: ObjectRef

  @Field({ nullable: true, description: 'Name of the field in the dataset this metric maps to.' })
  fieldName?: string

  @Field({ nullable: true, description: 'Indicates whether this metric is active and usable.' })
  active?: boolean

  @Field({
    nullable: true,
    description: 'Cron schedule string for periodic KPI value aggregation (e.g., "0 0 * * *" for daily).'
  })
  schedule?: string

  @Field(type => GraphQLUpload, { nullable: true, description: 'Thumbnail image or file for this metric.' })
  thumbnail?: FileUpload

  @Field({ nullable: true, description: 'Timezone for the schedule.' })
  timezone?: string
  @Field({ nullable: true, description: 'Schedule ID for the registered cron job.' })
  scheduleId?: string

  @Field(type => KpiPeriodType, { nullable: true, description: 'Aggregation period type for this metric.' })
  periodType?: KpiPeriodType

  @Field(type => KpiMetricCollectType, { nullable: true, description: '데이터 수집 방식' })
  collectType?: KpiMetricCollectType

  @Field(type => Int, { nullable: true, description: '목록 표시 순서(오름차순). 미지정(null)은 뒤로 정렬.' })
  rank?: number

  @Field(type => ScalarObject, {
    nullable: true,
    description: '확장 메타(JSON). 입력 위젯 힌트(meta.input) 등. 스키마 변경 없이 확장.'
  })
  meta?: any
}

@InputType()
export class KpiMetricPatch {
  @Field(type => ID, { nullable: true })
  id?: string

  @Field({ nullable: true })
  name?: string

  @Field({ nullable: true })
  description?: string

  @Field({ nullable: true })
  unit?: string

  @Field({ nullable: true })
  source?: string

  @Field(type => ObjectRef, { nullable: true })
  dataSet?: ObjectRef

  @Field({ nullable: true })
  fieldName?: string

  @Field({ nullable: true })
  active?: boolean

  @Field({
    nullable: true,
    description: 'Cron schedule string for periodic KPI value aggregation (e.g., "0 0 * * *" for daily).'
  })
  schedule?: string

  @Field(type => GraphQLUpload, { nullable: true })
  thumbnail?: FileUpload

  @Field({ nullable: true, description: 'Timezone for the schedule.' })
  timezone?: string

  @Field({ nullable: true, description: 'Schedule ID for the registered cron job.' })
  scheduleId?: string

  @Field(type => KpiPeriodType, { nullable: true, description: 'Aggregation period type for this metric.' })
  periodType?: KpiPeriodType

  @Field({ nullable: true })
  cuFlag?: string

  @Field(type => KpiMetricCollectType, { nullable: true, description: '데이터 수집 방식' })
  collectType?: KpiMetricCollectType

  @Field(type => Int, { nullable: true, description: '목록 표시 순서(오름차순). 미지정(null)은 뒤로 정렬.' })
  rank?: number

  @Field(type => ScalarObject, {
    nullable: true,
    description: '확장 메타(JSON). 입력 위젯 힌트(meta.input) 등. 스키마 변경 없이 확장.'
  })
  meta?: any
}

@ObjectType()
export class KpiMetricList {
  @Field(type => [KpiMetric])
  items: KpiMetric[]

  @Field(type => Int)
  total: number
}
